'use client';
import React from 'react';
import { ScannerManager, RelatedSymbol } from '@benzinga/scanner-manager';
import { StockSymbol } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';

const SCANNER_FIELD_MAP: Record<string, string> = {
  change: 'change',
  changePercent: 'changePercent',
  close: 'close',
  dividend: 'dividend',
  dividendYield: 'dividendYield',
  exchange: 'exchange',
  forwardPERatio: 'forwardPERatio',
  marketCap: 'marketCap',
  name: 'name',
  pe: 'priceToEarnings',
  shareFloat: 'shareFloat',
  sharesOutstanding: 'sharesOutstanding',
  symbol: 'symbol',
};

const mapFieldsToScanner = (fields: string[]): string[] => {
  const scannerFields = fields.map(field => SCANNER_FIELD_MAP[field] ?? field);
  return [...new Set(['symbol', 'name', 'gicsSectorName', 'marketCap', ...scannerFields])];
};

export const useRelatedSymbols = (symbol: StockSymbol, fields: string[], softChange?: boolean) => {
  const session = React.useContext(SessionContext);
  const [relatedSymbols, setRelatedSymbols] = React.useState<RelatedSymbol[] | undefined>(undefined);

  React.useEffect(() => {
    const fetchRelatedSymbols = async () => {
      if (!softChange) {
        setRelatedSymbols(undefined);
      }

      const peers = await session.getManager(ScannerManager).getRelatedSymbols({
        fields: mapFieldsToScanner(fields),
        symbol,
      });
      setRelatedSymbols(peers);
    };
    fetchRelatedSymbols();
  }, [symbol, session, fields, softChange]);

  return relatedSymbols;
};
